"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var uuid_1 = __importDefault(require("uuid"));
var focusable_1 = __importDefault(require("ally.js/esm/query/focusable"));
var _1 = require(".");
var Window = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: auto;\n\twidth: auto;\n\theight: auto;\n\tmin-width: 25%;\n\tmax-width: 75%;\n\tmax-height: 80%;\n\n\t@media ", ", ", " {\n\t\tmax-width: unset;\n\t\tmax-height: unset;\n\t\tmin-width: 100%;\n\t\tmin-height: 100%;\n\t}\n\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\talign-items: stretch;\n\tpointer-events: auto;\n\n\t", "\n"], ["\n\tmargin: auto;\n\twidth: auto;\n\theight: auto;\n\tmin-width: 25%;\n\tmax-width: 75%;\n\tmax-height: 80%;\n\n\t@media ", ", ", " {\n\t\tmax-width: unset;\n\t\tmax-height: unset;\n\t\tmin-width: 100%;\n\t\tmin-height: 100%;\n\t}\n\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\talign-items: stretch;\n\tpointer-events: auto;\n\n\t", "\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.fullScreenStream; }, function (props) { return props.theme.dialog.window; });
var Dialog = /** @class */ (function (_super) {
    __extends(Dialog, _super);
    function Dialog(props) {
        var _this = _super.call(this, props) || this;
        _this.isVisible = function () {
            /* https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom */
            return _this.windowRef.current && _this.windowRef.current.offsetParent !== null;
        };
        _this.onKeyPress = function (ev) {
            if (_this.isVisible()) {
                var ESC = 27;
                if (ev.keyCode === ESC) {
                    _this.props.onClose();
                }
            }
        };
        _this.onClick = function (ev) {
            ev.stopPropagation();
            ev.preventDefault();
        };
        _this.originalFocus = document.activeElement;
        _this.windowId = "dialog-" + uuid_1.default.v4();
        _this.windowRef = react_1.default.createRef();
        return _this;
    }
    Dialog.prototype.componentDidMount = function () {
        //Need to move focus into the dialog
        var focusable = focusable_1.default("#" + (this.props.id || this.windowId));
        if (focusable[0]) {
            focusable[0].focus();
        }
        if (this.windowRef.current) {
            document.addEventListener("keydown", this.onKeyPress);
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        if (this.windowRef.current) {
            document.removeEventListener("keydown", this.onKeyPress);
        }
        if (this.originalFocus && document.activeElement && document.activeElement.closest("#" + (this.props.id || this.windowId))) {
            this.originalFocus.focus();
        }
    };
    Dialog.prototype.render = function () {
        return (react_1.default.createElement(_1.Modal, null,
            react_1.default.createElement(_1.Fader, { onClick: this.props.onClose },
                react_1.default.createElement(Window, { className: this.props.className, id: this.props.id || this.windowId, ref: this.windowRef, onClick: this.onClick, role: "dialog", "aria-modal": "true", "aria-label": this.props.title.text, "aria-labelledby": this.props.title.id, "aria-describedby": this.props.descriptionId }, this.props.children))));
    };
    Dialog.propTypes = {
        onClose: prop_types_1.default.func.isRequired,
        children: prop_types_1.default.node.isRequired,
        /** id to give the root of the dialog instead of a generated one  */
        id: prop_types_1.default.string,
        /** id of the element containing the title, or the actual text value */
        title: prop_types_1.default.oneOfType([prop_types_1.default.exact({ id: prop_types_1.default.string.isRequired }), prop_types_1.default.exact({ text: prop_types_1.default.string.isRequired })]).isRequired,
        /** id of the element containing the primary message */
        descriptionId: prop_types_1.default.string
    };
    Dialog.defaultProps = {
        onClose: function () { },
        children: '',
        title: { text: '' },
    };
    return Dialog;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Dialog);
var templateObject_1;
//# sourceMappingURL=Dialog.js.map